import { useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import {
  Box,
  TextField,
  Typography,
  Button,
  useTheme,
} from "@mui/material";
import { useTranslation } from "react-i18next";
import AppBackground from "../components/layout/AppBackground";

const ResetPassword = () => {
  const { token } = useParams();
  const { t } = useTranslation("reset");
  const navigate = useNavigate();
  const theme = useTheme();
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [error, setError] = useState("");
  const [successMsg, setSuccessMsg] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    if (newPassword !== confirmPassword) {
      setError(t("passwords_mismatch"));
      return;
    }
    if (!newPassword || newPassword.length < 4) {
      setError(t("invalid_password"));
      return;
    }

    setLoading(true);
    try {
      const res = await fetch(`${process.env.REACT_APP_API_URL}/auth/reset-password/${token}`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ new_password: newPassword }),
      });

      const data = await res.json();
      if (res.ok) {
        setSuccessMsg(t("success"));
        setTimeout(() => navigate("/login"), 3000);
      } else {
        setError(data.msg || t("error"));
      }
    } catch {
      setError(t("network_error"));
    } finally {
      setLoading(false);
    }
  };

  return (
    <AppBackground
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <Box
        component="form"
        onSubmit={handleSubmit}
        sx={{
          backgroundColor: "#212121",
          color: "#fff",
          borderRadius: 4,
          p: 4,
          maxWidth: 400,
          width: "100%",
          textAlign: "center",
          boxShadow: "0 0 20px rgba(0,0,0,0.5)",
        }}
      >
        <Typography variant="h5" gutterBottom>
          {t("title")}
        </Typography>

        <TextField
          label={t("new_password")}
          type="password"
          fullWidth
          margin="normal"
          value={newPassword}
          onChange={(e) => setNewPassword(e.target.value)}
          inputProps={{ maxLength: 50 }}
          InputLabelProps={{ shrink: true }}
        />
        <TextField
          label={t("confirm_password")}
          type="password"
          fullWidth
          margin="normal"
          value={confirmPassword}
          onChange={(e) => setConfirmPassword(e.target.value)}
          inputProps={{ maxLength: 50 }}
          InputLabelProps={{ shrink: true }}
        />

        {error && <Typography color="error" sx={{ mt: 2 }}>{error}</Typography>}
        {successMsg && <Typography color="success.main" sx={{ mt: 2 }}>{successMsg}</Typography>}

        <Button
          type="submit"
          variant="contained"
          fullWidth
          sx={{ mt: 3, borderRadius: 999, py: 1.2 }}
          disabled={loading}
        >
          {loading ? t("saving") : t("submit")}
        </Button>
      </Box>
    </AppBackground>
  );
};

export default ResetPassword;
